/**
 * Filteren en sorteren op de collectie- en zoekpagina.
 *
 * Werkt bovenop Shopify's eigen filtering. Zonder JavaScript verstuurt het
 * formulier normaal en werkt alles nog steeds; met JavaScript worden de
 * resultaten zonder paginaverversing bijgewerkt.
 */
(function () {
  'use strict';

  // Voorkomt dubbele initialisatie wanneer dit bestand twee keer wordt ingeladen.
  if (window.__themeFacets) return;
  window.__themeFacets = true;

  function updateResults(searchParams, updateUrl) {
    var results = document.querySelector('[data-collection-results]');
    if (!results) return;

    results.classList.add('is-loading');

    fetch(window.location.pathname + '?' + searchParams)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var newResults = parsed.querySelector('[data-collection-results]');
        if (newResults) results.innerHTML = newResults.innerHTML;

        var newFilters = parsed.querySelector('[data-facet-form]');
        var currentFilters = document.querySelector('[data-facet-form]');
        if (newFilters && currentFilters) {
          // Onthoud welke groepen openstonden
          var openState = [];
          currentFilters.querySelectorAll('details').forEach(function (details, index) {
            openState[index] = details.open;
          });
          currentFilters.innerHTML = newFilters.innerHTML;
          currentFilters.querySelectorAll('details').forEach(function (details, index) {
            if (typeof openState[index] === 'boolean') details.open = openState[index];
          });
        }

        var newCount = parsed.querySelector('.collection-toolbar__count');
        var currentCount = document.querySelector('.collection-toolbar__count');
        if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;

        if (updateUrl && window.history.pushState) {
          window.history.pushState({ searchParams: searchParams }, '', window.location.pathname + '?' + searchParams);
        }
      })
      .catch(function () {
        // Bij een fout laden we de pagina normaal, zodat de klant nooit vastloopt.
        window.location.search = searchParams;
      })
      .finally(function () {
        results.classList.remove('is-loading');
      });
  }

  function buildParams() {
    var params = [];

    var facetForm = document.querySelector('[data-facet-form]');
    if (facetForm) {
      params.push(new URLSearchParams(new FormData(facetForm)).toString());
    }

    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect && sortSelect.value) {
      params.push('sort_by=' + encodeURIComponent(sortSelect.value));
    }

    // Lege waarden eruit filteren
    return params
      .join('&')
      .split('&')
      .filter(function (pair) {
        return pair && pair.split('=')[1];
      })
      .join('&');
  }

  function init() {
    var facetForm = document.querySelector('[data-facet-form]');
    var sortSelect = document.querySelector('[data-sort-select]');

    if (facetForm) {
      facetForm.addEventListener('input', function (event) {
        if (!event.target.matches('[data-facet-input]')) return;
        // Prijsvelden pas na een korte pauze, checkboxes meteen
        if (event.target.type === 'number') {
          clearTimeout(window.__facetTimer);
          window.__facetTimer = setTimeout(function () {
            updateResults(buildParams(), true);
          }, 600);
        } else {
          updateResults(buildParams(), true);
        }
      });

      facetForm.addEventListener('submit', function (event) {
        event.preventDefault();
        updateResults(buildParams(), true);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        updateResults(buildParams(), true);
      });
    }
  }

  window.addEventListener('popstate', function () {
    updateResults(window.location.search.slice(1), false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
